export const DATE_TIME_REGEX = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
export const DAY_INDEX = 3;
export const MONTH_INDEX = 2;
export const MONTH_INDEX_ADJUSTMENT = 1;
export const YEAR_INDEX = 1;
export const POPULAR_EVENT_SCHEDULE = 'c-event-schedule';
export const POPULAR_EVENT_SCHEDULE_LIVE = `${POPULAR_EVENT_SCHEDULE}__live-tag`;
export const POPULAR_EVENT_SCHEDULE_INFO = `${POPULAR_EVENT_SCHEDULE}__info`;
export const POPULAR_EVENT_SCHEDULE_DATE = `${POPULAR_EVENT_SCHEDULE_INFO}-date`;
export const POPULAR_EVENT_SCHEDULE_TIME = `${POPULAR_EVENT_SCHEDULE_INFO}-time`;
export const I18N_POPULAR_EVENT_SCHEDULE_LIVE = 'event_schedule.live';

